@if (errorMessage) {
  <tidy-error-message
    [text]="errorMessage" />
}

@if (message?.type != 'cleaning_update') {
  <tidy-card style="border-radius: 10px;" [ngStyle]="{'min-height': message?.content?.files?.length > 0 ? '180px' : 'auto'}">
    @if (!isInvoiceNote) {
      <!--TODO: Add logic to only show IF suggestion AND status == 'waiting'-->
      @if (message?.content?.chat_suggestion?.name == 'reschedule_booking' && message?.content?.chat_suggestion?.status == 'waiting') {
        <div [ngStyle]="internalNoteStyleObject">
          <tidy-row [alignLastItemRight]="true" >
            <tidy-image
              [src]="'assets/img/tidy-ai.svg'"
              class="title-size" />
            <tidy-text
              [body]="'TIDY Concierge'"
              [translate]="false" />
            <tidy-text
              style=" margin: 3px 0px 0px 5px"
              [smallHelper]="messageDateTime" />
            <tidy-text
              [actionBody]="'Dismiss'"
              (action)="dismissSuggestion()"
              class="red link" />
          </tidy-row>
          <tidy-row [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}">
            <tidy-text
              [body]="('Want to reschedule your ' | translate) + message?.metadata?.service_type_details?.name + '?'" />
          </tidy-row>
          @if (message?.content?.chat_suggestion?.data?.new_date) {
            <tidy-row [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}">
              <tidy-text
                [body]="('Old time: ' | translate) + getSuggestionJobDate(message?.metadata?.job?.date) + (' at ' | translate) + getSuggestionJobTime(message?.metadata?.job?.start_time)" />
            </tidy-row>
            <tidy-row [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}" class="extra-bottom-padding">
              <tidy-text
                [body]="('New time: ' | translate) + getSuggestionJobDate(message?.content?.chat_suggestion?.data?.new_date) + (' at ' | translate) + getSuggestionJobTime(message?.content?.chat_suggestion?.data?.new_start_time)" />
            </tidy-row>
            <tidy-row [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}" class="extra-bottom-padding vertical-align-center">
              <tidy-image
                [src]="'assets/svg/checkmark-circle-outline.svg'"
                class="header-size" />
              <tidy-text
                [actionBody]="'Reschedule Job'"
                class="link"
                (action)="rescheduleJob()" />
            </tidy-row>
          }
          <tidy-row [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}" class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/information-circle-outline.svg'"
              class="header-size" />
            <tidy-text
              [actionBody]="message?.content?.chat_suggestion?.data?.new_date ? 'View Other Times' : 'View Times'"
              class="link"
              (action)="goToBookingViewRescheduleJob()" />
          </tidy-row>
        </div>
      }
      <!--TODO: Add logic to only show IF suggestion AND status == 'waiting'-->
      @if (message?.content?.chat_suggestion?.name == 'cancel_booking' && message?.content?.chat_suggestion?.status == 'waiting') {
        <div [ngStyle]="internalNoteStyleObject">
          <tidy-row [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/img/tidy-ai.svg'"
              class="title-size" />
            <tidy-text
              [body]="'TIDY Concierge'"
              [translate]="false" />
            <tidy-text
              style=" margin: 3px 0px 0px 5px"
              [smallHelper]="messageDateTime" />
            <tidy-text
              [actionBody]="'Dismiss'"
              (action)="dismissSuggestion()"
              class="red link" />
          </tidy-row>
          <tidy-row [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}">
            <tidy-text
              [body]="('Want to cancel your ' | translate) + message?.metadata?.service_type_details?.name + '?'" />
          </tidy-row>
          <tidy-row [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}" class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/close-circle-outline.svg'"
              class="header-size" />
            <tidy-text
              [actionBody]="'Cancel Job'"
              class="link"
              (action)="cancelJob()" />
          </tidy-row>
        </div>
      }
      @if (message?.type == 'text') {
 <div [ngStyle]="getMessageStyles(message)">
          <div style="display: flex; flex-direction: row;">
            <div style="margin-right: 5px;">
              @if (message?.is_internal) {
                <tidy-image
                  class="title-size"
                  [src]="'assets/svg/create.svg'" />
              }
              @if (!message?.is_internal) {
                <tidy-initials-icon
                  [fullName]="message?.from_member?.first_name == 'Guest' ? 'Guest' : message?.from_member?.first_name + ' ' + message?.from_member?.last_name"
                  [isUnknownNumber]="isUnknownNumber" />
              }
            </div>
            <div style="flex: 1; margin-top: -3px">
              <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                <tidy-text
                  [body]="'<b>' + message?.from_member?.first_name + '</b>'"
                  [translate]="false" />
                <tidy-text
                  [smallHelper]="messageDateTime" />
              </div>
              @if (message?.content?.text !== '' && message?.content?.text) {
                <div>
                  <tidy-text
                    [body]="message?.content?.text"
                    [checkLineBreaks]="true" />
                </div>
              }
              @for (media of message?.content?.files; track media) {
                <tidy-photo-note
                  style="max-width: 150px"
                  [src]="media" />
              }
            </div>
          </div>
          @if (message?.content?.phone_status == 'failed') {
            <tidy-row class="vertical-align-middle" [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}" style="padding-bottom: 0px">
              <tidy-image
                [src]="'assets/img/alert-circle-outline-red.svg'"
                class="body-size" />
              <tidy-text
                class="red"
                [smallBody]="message?.content?.error_message" />
            </tidy-row>
          }
        </div>
      }
      @if (message?.type == 'phone_call') {
        <tidy-row class="vertical-align-center" [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}">
          <tidy-image
            [src]="'assets/img/phone-black.svg'"
            class="phone-icon"
            [ngClass]="(message?.content?.text == 'Calling...' || message?.content?.text == 'Call in-progress...') ? 'wiggle-animation' : ''" />
          <tidy-text
            [body]="message?.from_member?.first_name"
            [translate]="false" />
          <tidy-text
            style="margin: 3px 0px 0px 5px"
            [smallHelper]="messageDateTime" />
          @if (message?.metadata?.job?.id && showJobLink) {
            <tidy-image
              [src]="'assets/svg/briefcase-outline.svg'"
              style="font-size: 13px; margin-left: 10px; margin-top: 3px; opacity: 30%" />
            <div
          style="color: #00AABA;
          font-family: 'Inter';
          font-size: 13px;
          font-weight: 400;
          text-decoration: underline;
          margin: 3px 0px 0px 0px;
          cursor: pointer"
              (click)="goToJobPage(message?.metadata?.job)">
              {{getJobDate(message?.metadata?.job?.start_datetime, message?.job?.timezone_name)}} Job
            </div>
          }
        </tidy-row>
        <tidy-row [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}">
          <tidy-text
            [body]="'<i>' + message?.content?.text + '</i>'" />
          @if (message?.content?.text == 'Call finished.') {
            <tidy-text
              [body]="'<i>' + communication.getCallMinutes(message?.content?.phone_status?.duration) + '</i>'" />
          }
        </tidy-row>
      }
    }
    @if (isInvoiceNote) {
      <div [class.internal-note]="message?.is_internal">
        <tidy-row class="vertical-align-center">
          @if (message?.is_internal) {
            <tidy-image
              class="title-size"
              [src]="'assets/svg/create.svg'" />
          }
          @if (!message?.is_internal) {
            <tidy-initials-icon
              [fullName]="message?.created_by"
              [isUnknownNumber]="isUnknownNumber" />
          }
          <tidy-text
            [body]="message?.created_by"
            [translate]="false" />
          @if (message?.sent_at) {
            <tidy-text
              style="margin: 3px 0px 0px 5px"
              [smallHelper]="messageDateTime" />
          }
        </tidy-row>
        @if (message?.media_url) {
          <tidy-row [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}" [alignLastItemRight]="true" style="padding-bottom: 0px; margin-top:-5px">
            <tidy-photo-note
              style="max-width: 150px"
              [src]="message.media_url"
              (imagesLoaded)="onPhotoNoteLoaded()" />
          </tidy-row>
        }
        @if (message?.text !== '' && message?.text) {
          <tidy-row [ngClass]="{'extra-left-padding': addExtraPadding, 'extra-right-padding': addExtraPadding}" style="padding-bottom: 0px">
            <tidy-text
              [body]="message?.text" />
          </tidy-row>
        }
      </div>
    }
  </tidy-card>
}

@if (message?.type == 'cleaning_update') {
  <tidy-text
    style="margin-right: 5px"
    [smallHelper]="messageDateTime" />
  <tidy-row class="vertical-align-middle">
    <tidy-text
      [body]="'<i>' + message?.data?.text + '</i>'" />
  </tidy-row>
}
